import * as S from './styles';

interface ILoaderProps {
  bg_color?: string;
}

const Loader = ({ bg_color }: ILoaderProps) => {
  return (
    <S.LoaderContainer>
      <S.Loader bg_color={bg_color} />
    </S.LoaderContainer>
  );
};

export default Loader;
